// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__39a8i","consentsList":"PatientConsents_consentsList__qun0H","consentsListEmpty":"PatientConsents_consentsListEmpty__w-SH-"};